import React, { ReactNode } from 'react';
import { Button, FlexRow, FormCell, Grid, Header2Text } from 'ui-toolkit/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons';

interface ContactsPageTemplateProps {
  hintText: string | ReactNode;
  header: string;
  addContact: () => void;
  children: ReactNode;
}

export const ContactsPageTemplate: React.FC<ContactsPageTemplateProps> = ({
  header,
  hintText,
  addContact,
  children,
}) => {
  return (
    <Grid>
      <FlexRow justifyContent={'space-between'} width={100}>
        <FormCell hintText={hintText}>
          <Header2Text>{header}</Header2Text>
        </FormCell>
        <Button intent={'secondary'} onClick={addContact}>
          <FontAwesomeIcon icon={faUserPlus} /> Add New Contact
        </Button>
      </FlexRow>
      {children}
    </Grid>
  );
};
